import { createFileRoute } from '@tanstack/react-router'
import { OnboardingWizard } from '@/features/onboarding/onboarding-wizard'

/**
 * Route shell for the customer onboarding wizard — plan 50 Task 12.
 *
 * Per the route-shell rule, this file is a route definition and a render. The
 * wizard lives in `src/features/onboarding/`.
 */
export const Route = createFileRoute('/_authenticated/onboarding')({
  component: OnboardingRoute,
})

function OnboardingRoute() {
  return <OnboardingWizard />
}
